import React from "react";
import { ButtonSize, ButtonTheme, RoundedButton } from "../../components/buttons/roundedButton/RoundedButton";
import { useEvent } from "../../contexts/EventContext";
import { useServices } from "../../contexts/ServiceContext";
import { GameActions, GameState } from "../../controllers/GameController";

type FavouritesButtonProps = {
    state: GameState;
    dispatch: React.Dispatch<GameActions>;
};

export const FavouritesButton = ({ state, dispatch }: FavouritesButtonProps): JSX.Element => {
    const { edgeDeploy } = useServices();
    const { currentEvent } = useEvent();
    const { favoritesButtonPressed } = state;

    if (!currentEvent) {
        return <></>;
    }

    const handleFavouriteButtonPressed = () => {
        if (currentEvent.horseRacingPrompts.length === 0) {
            // console.log("not for horse racing events");
            const choices = [...state.choices];

            let count = 0;
            for (const platformEvent of currentEvent.platformEvents) {
                for (const platformOffer of platformEvent.platformOffers) {
                    let choice = 0;
                    if (platformOffer.platformOutcomes[0].odds > platformOffer.platformOutcomes[1].odds) {
                        choice = 1;
                    }

                    const currentPick = {
                        platformEventId: platformOffer.platformEvent,
                        platformOfferId: platformOffer.platformOutcomes[choice].platformOffer,
                        platformOutcomeId: platformOffer.platformOutcomes[choice].id,
                    };
                    choices[count] = currentPick;
                    count++;
                }
            }

            dispatch({ type: "setChoices", choices });
            dispatch({ type: "setButtonState", random: false, favourites: true });
        }
    };

    return (
        <RoundedButton
            config={{
                buttonText: "Favorites",
                size: edgeDeploy ? ButtonSize.LARGE : ButtonSize.MEDIUM,
                theme: ButtonTheme.BASE,
                margin: { right: 5 },
                isActive: favoritesButtonPressed,
            }}
            testID={"favorites"}
            onPress={handleFavouriteButtonPressed}
        />
    );
};
